import { useState } from "react";
import { PlusCircle } from "lucide-react";
import { toast } from "sonner";
import { money, formatApiError, startCheckout } from "../lib/api";

const PRESETS = [25, 50, 100, 250];

export const ExtraFundCard = ({ m }) => {
  const [amount, setAmount] = useState(50);
  const [busy, setBusy] = useState(false);
  const active = m?.status === "active";
  const add = async () => {
    setBusy(true);
    try { await startCheckout({ kind: "extra", tier: m.tier, amount: Number(amount) }); }
    catch (e) { toast.error(formatApiError(e)); setBusy(false); }
  };
  return (
    <div data-testid="extra-fund-card" className="lux-card p-6 md:p-8">
      <p className="eyebrow">Trip upgrade fund</p>
      <p data-testid="extra-fund-balance" className="font-mono-lux text-3xl mt-3 text-[#38BDF8]">{money(m?.extra_balance)}</p>
      <p className="text-sm text-slate-400 mt-2">Pay extra anytime — 100% is added on top of this line's trip budget when your turn comes.</p>
      <div className="mt-5 flex flex-wrap gap-2">
        {PRESETS.map((p) => (
          <button key={p} data-testid={`extra-preset-${p}`} onClick={() => setAmount(p)}
            className={`px-4 py-1.5 rounded-full text-sm font-mono-lux border transition-colors ${Number(amount) === p ? "border-[#38BDF8] text-[#38BDF8]" : "border-white/10 text-slate-300"}`}>${p}</button>
        ))}
      </div>
      <div className="mt-4 flex gap-2">
        <input data-testid="extra-amount-input" type="number" min="1" value={amount} onChange={(e) => setAmount(e.target.value)} className="lux-input font-mono-lux" />
        <button data-testid="extra-add-btn" disabled={busy || !active || !(Number(amount) > 0)} onClick={add} className="btn-gold px-5 inline-flex items-center gap-2 whitespace-nowrap">
          <PlusCircle className="w-4 h-4" />{busy ? "…" : "Add"}
        </button>
      </div>
      {!active && <p className="text-xs text-slate-500 mt-3">Join this line to start an upgrade fund.</p>}
    </div>
  );
};
